import React, { useCallback, useState } from "react";
import { AutoComplete, Input, Typography } from "antd";
import debounce from "lodash.debounce";
import { searchLocations } from "../../../utils/common";
import { DownOutlined } from "@ant-design/icons";
import styles from "./custom-autocomplete.module.css";

const { Text } = Typography;

export function CustomAutoComplete({
  id,
  label,
  value,
  onChange,
  onSelect,
  placeholder,
  labelColor = "#171717",
  errorMessage,
  className,
  disabled,
  prefix,
  status,
  showRequired = false,
  showOptional = false,
}) {
  const [suggestions, setSuggestions] = useState([]);

  const searchPlaces = async (query) => {
    const data = await searchLocations(query);
    const map = new Map();
    
    data?.forEach((item) => {
      if (!map.has(item?.display_name)) {
        map.set(item?.display_name, {
          key: item?.place_id,
          value: item?.display_name,
          lat: item?.lat,
          lng: item?.lon,
        });
      }
    });
    setSuggestions(Array.from(map.values()));
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      searchPlaces(term);
    }, 500),
    []
  );

  const handleSelectOption = (_, option) => {
    setSuggestions([]);
    onSelect({
      lat: Number(option.lat),
      lng: Number(option.lng),
    });
  };

  const handleOnChange = (val) => {
    onChange(val);
    setSuggestions([]);
    debouncedSearch(val);
  };

  return (
    <div className={`${styles['custom-autocomplete']} ${className}`}>
      {label ? (
        <div style={{ marginBottom: 8, fontWeight: 400, color: labelColor }}>
          {label}
          {showRequired ? (
            <span style={{ color: "red" }}>*</span>
          ) : showOptional ? (
            <span  style={{ color: "#8C8C8C" }}>
              {typeof showOptional === "string" ? ` ${showOptional}` : " (Optional)"}
            </span>
          ) : null}
        </div>
      ) : null}
      <AutoComplete
        id={id}
        style={{ width: "100%", height: 40 }}
        options={suggestions}
        value={value}
        onSelect={handleSelectOption}
        onChange={handleOnChange}
        disabled={disabled}
      >
        <Input
          placeholder={placeholder}
          prefix={prefix}
          suffix={<DownOutlined style={{ color: "#9ca3af" }} />}
          status={status}
          onPaste={(e) => e.preventDefault()}
          onCopy={(e) => e.preventDefault()}
          onCut={(e) => e.preventDefault()}
          style={{ height: 40 }}
        />
      </AutoComplete>
      {errorMessage && (
        <Text type="danger" style={{ marginTop: 5, display: "block" }}>
          {errorMessage}
        </Text>
      )}
    </div>
  );
}

export default CustomAutoComplete;
